import script from "./main.vue?vue&type=script&lang=ts&setup=true"
export * from "./main.vue?vue&type=script&lang=ts&setup=true"

import "./main.vue?vue&type=style&index=0&id=0d3c48a4&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d3c48a4"]])

export default __exports__